// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Toastr } from "@revvsales/components";

import DocumentV2 from "../DocumentV2";
import PdfDocument from "./PdfDocument";
// // Components Imports
// import withRbac from "../../app/withRbac";
// import DocumentHeader from "./DocumentHeader";
// import DocumentView from "./DocumentView";
// // import ApproxPageBreak from "./ApproxPageBreak";
// import ClauseOptions from "./ClauseOptions";
// import CloneTemplatePopup from "../DocTemplates/CloneTemplatePopup";
// import CustomRevvToolbar from "../CustomRevvToolbar";

// ACTION IMPORTS
import { ToolbarActions, QuotationActions } from "../../actions";

// Actions Imports
import {
  addDocumentComponentAction,
  deleteDocumentComponentAction,
  updateComponentsDBRowColIndexesAction,
  updateDocumentComponentAction,
  changeDocFormValidFlag,
  fetchDynamicFields,
  updateDraggedSection,
  toggleDocumentDiffView,
  updateDocumentClickedComponentID,
  // UNDO/REDO ACTIONS
  reactionsOnRedoClick,
  reactionsOnUndoClick,
  updateDocMeta,
  coverpageThemeAction,
  changeToolsView,
  updateHoveredDocumentSectionId,
  updateOutlineLabel,
  removeHighlightSelectionInDocument,
  deleteDocSignerSection,
  executeCommand,
  removeComponentInDocument,
  undoComponentUpdate,
  forceUpdateEditorSectionIdAction,
  toggleCoverpageView,
} from "../../actions/DocumentActions/index";

import { updateDocSaveIndicator } from "../../actions/DocumentActions/method";

import { updateTemplateMeta } from "../../actions/DocumentTemplateActions/templateActions";
import {
  nukeEditorState,
  initEditorState,
  updateEditorStateIfActive,
} from "../../actions/EditorActions/editorActions";

import { PIPELINE, DOCUMENTS } from "../../constants";
// import {
//   emptyQuoteTablePlaceholder,
//   googleSheetSpace,
//   // emptyContainer,
//   // getContentForComponent,
// } from "../../utils/documentUtils";

import AddComponentCommand from "../../commands/addComponentCommand";
import DeleteComponentCommand from "../../commands/deleteComponentCommand";
import UpdateComponentCommand from "../../commands/updateComponentCommand";
import UndoRedoObserver from "../UndoRedoObserver";

// Destructuring
const {
  addDealTableTab,
  updateToolPaneData,
  setSectionDataForActiveSignatureInRightToolPane,
  setSectionDataForActivePaymentButtonInRightToolPane,
} = QuotationActions;
const { updateAddComponentinToolbarAction } = ToolbarActions;
const {
  // DOCUMENT_COMPONENT_TYPES,
  DOCUMENT_ZOOM_CONFIGS,
  DOCUMENT_DEFAULT_BG_COLOR,
} = DOCUMENTS;
const { DOCUMENT_STATUS_HASMAP } = PIPELINE;

// Declaration
const DOCUMENT = "DOCUMENT";
const TEMPLATE = "TEMPLATE";
const FORM = "FORM";

class Document extends Component {
  customToolbarRef = React.createRef();

  docBgColorDropdownRef = React.createRef();

  constructor(props) {
    super(props);
    let savedBgColor = null;
    // let savedZoom = null;
    if (props.metaData) {
      savedBgColor = props.metaData.documentBgColor;
      // savedZoom = props.metaData.zoomSetting;
    }
    this.state = {
      // showCloneTemplatePopup: false,
      showOutlineView: false,
      zoomSetting: DOCUMENT_ZOOM_CONFIGS["100"],
      documentBgColor: savedBgColor || DOCUMENT_DEFAULT_BG_COLOR,
      showDocBgColorDropdown: false,
    };
  }

  componentDidMount = async () => {
    this.props.changeDocFormValidFlag();
    // TODO: remove below call and add this to getInitData or something like that
    this.props.updateDraggedSection(null, null);
    if (this.props.mode === DOCUMENT) this._updateSaveIndicator();
  };

  componentWillUnmount() {
    this.props.updateAddComponentinToolbarAction(null);
  }

  _updateSaveIndicator = () => {
    if (
      (this.props.layout === null ||
        this.props.layout === undefined ||
        (Array.isArray(this.props.layout) && this.props.layout.length === 0)) &&
      this.props.metaData &&
      Object.keys(this.props.metaData).length === 0
    ) {
      this.props.updateDocSaveIndicator("HIDE");
    }
  };

  _removeActiveComponents = () => {
    const oldComponents = document.getElementsByClassName("active-component");
    for (let i = 0; i < oldComponents.length; i += 1) {
      oldComponents[i].classList.remove("active-component");
    }
  };

  _setDraggedSection = (section, draggedFrom) => {
    this.props.updateDraggedSection(section, draggedFrom);
  };

  _removeSection = (sectionID, section) => {
    const {
      signerData,
      mode,
      docNo,
      layout,
      dealTableId,
      isPdfDocument,
      docID,
      updateSectionService,
      deleteSectionService,
    } = this.props;

    const deleteCommand = new DeleteComponentCommand({
      sectionID,
      section,
      mode,
      deleteDocumentComponentAction: this.props.deleteDocumentComponentAction,
      isPdfDocument,
      signerData: [...signerData],
      deleteDocSignerSection: this.props.deleteDocSignerSection,
      docID,
      updateSectionService,
      deleteSectionService,
      docNo,
      addDocumentComponentAction: this.props.addDocumentComponentAction,
      updateComponentsDBRowColIndexesAction: this.props
        .updateComponentsDBRowColIndexesAction,
      layout: [...layout],
      dealTableId,
      addDealTableTab: this.props.addDealTableTab,
    });
    this.props.executeCommand(deleteCommand);
  };

  _updateSection = (
    updatedSection,
    change,
    isMouseHover,
    oldSection,
    addedNewTextSection,
    unDoable,
  ) => {
    const {
      layout,
      components,
      mode,
      isTemplateTypeForm,
      clickedActiveComponentId,
      clickedSection,
    } = this.props;

    const updateCommand = new UpdateComponentCommand({
      mode,
      isTemplateTypeForm,
      layout: [...layout],
      components: { ...components },
      oldSection,
      isMouseHover,
      clickedActiveComponentId,
      clickedSection,
      updatedSection,
      updateDocumentComponentAction: this.props.updateDocumentComponentAction,
      updateSectionService: this.props.updateSectionService,
      addedNewTextSection,
      change,
      nukeEditorState: this.props.nukeEditorState,
      initEditorState: this.props.initEditorState,
      updateDocumentClickedComponentID: this.props
        .updateDocumentClickedComponentID,
      undoComponentUpdate: this.props.undoComponentUpdate,
      forceUpdateEditorSectionIdAction: this.props
        .forceUpdateEditorSectionIdAction,
      unDoable,
      toggleCoverpageView: this.props.toggleCoverpageView,
      updateEditorStateIfActive: this.props.updateEditorStateIfActive,
    });
    this.props.executeCommand(updateCommand);
  };

  _updateOutlineLabel = (sectionID, label) => {
    const { components } = this.props;
    if (components) {
      const section = components[sectionID];
      if (section) {
        const newSection = {
          ...section.content,
          label,
          section_name: label,
          header: label,
        };
        this.props.updateOutlineLabel(newSection, this.props.mode, section);
      }
    }
  };

  _reorderOutlineItemList = (newLayout, oldLayout) => {
    // Store current doc sections as a snapshot first then execute the below actions
    console.debug(oldLayout);
    // this.props.addToUndoStack({
    //   action: "re-order",
    //   layout: oldLayout,
    //   section: null,
    // });
    const { reOrderSectionListAction, reOrderSectionListService } = this.props;
    reOrderSectionListService(newLayout).then(() => {
      reOrderSectionListAction(newLayout);
    });
  };

  // _openCloneTemplatePopup = () => {
  //   this.setState({ showCloneTemplatePopup: true });
  // };

  // _closeCloneTemplatePopup = () => {
  //   this.setState({ showCloneTemplatePopup: false });
  // };

  _toggleDocumentDiffView = () => {
    this.props.toggleDocumentDiffView();
  };

  _toggleOutlineView = () => {
    this.setState(prevState => ({
      showOutlineView: !prevState.showOutlineView,
    }));
  };

  // Disable Approx Page Break for rel-20-05-2020
  // _showApproxPageBreak = () => {
  //   const { mode, sectionTypeList } = this.props;
  //   if (this.props.showForm) {
  //     if (this.state.currentView === DOCUMENT) {
  //       return (
  //         <ApproxPageBreak mode={mode} sectionTypeList={sectionTypeList} />
  //       );
  //     }
  //     return null;
  //   }
  //   return <ApproxPageBreak mode={mode} sectionTypeList={sectionTypeList} />;
  // };

  // _addNote = (text, editorState, component, removeHighlightSelection) => {
  //   const { docID } = this.props;
  //   const note = emptyNote(docID, null);
  //   note.content = {
  //     highlight: text,
  //     message: "",
  //   };
  //   note.anchor = {
  //     component: "DOCUMENT",
  //     action: "HIGHLIGHT",
  //   };
  //   note.component = component;
  //   note.editorState = editorState;
  //   note.updateSection = this._updateSection;
  //   note.removeHighlightSelection = removeHighlightSelection;
  //   this.props.addNote(note);
  //   this.props.changeToolsView("notes");
  // };

  _handleZoomIn = event => {
    event.preventDefault();
    event.stopPropagation();
    const { zoomSetting } = this.state;
    if (zoomSetting && zoomSetting.next) {
      const newZoom = DOCUMENT_ZOOM_CONFIGS[zoomSetting.next];
      this.setState({ zoomSetting: newZoom });
      // this._updateDocMeta("zoomSetting", newZoom, zoomSetting);
    }
  };

  _handleZoomOut = event => {
    event.preventDefault();
    event.stopPropagation();
    const { zoomSetting } = this.state;
    if (zoomSetting && zoomSetting.prev) {
      const newZoom = DOCUMENT_ZOOM_CONFIGS[zoomSetting.prev];
      this.setState({ zoomSetting: newZoom });
      // this._updateDocMeta("zoomSetting", newZoom, zoomSetting);
    }
  };

  _changeDocumentBgColor = (event, color) => {
    event.preventDefault();
    event.stopPropagation();
    const currentBGColor = this.state.documentBgColor;
    this.setState({
      documentBgColor: color,
    });
    this._updateDocMeta("documentBgColor", color, currentBGColor);
  };

  _updateDocMeta = (key, value, prevValue) => {
    const data = [
      {
        op: "replace",
        field: "meta_data",
        value: { meta_data: { ...this.props.metaData, [key]: value } },
      },
    ];
    if (this.props.mode === DOCUMENT) {
      this.props
        .updateDocMeta({ docId: this.props.docID, data })
        .then()
        .catch(() => {
          Toastr.showToastr({
            type: "failure",
            message: "Oops, Something went wrong!!",
            timeout: 3000,
          });
          this.setState({
            [key]: prevValue,
          });
        });
    } else if (this.props.mode === TEMPLATE) {
      this.props
        .updateTemplateMeta({ docId: this.props.docID, data })
        .then()
        .catch(() => {
          Toastr.showToastr({
            type: "failure",
            message: "Oops, Something went wrong!!",
            timeout: 3000,
          });
          this.setState({
            [key]: prevValue,
          });
        });
    }
  };

  _toggleDocBgColorDropdown = event => {
    if (event) {
      event.stopPropagation();
    }
    // attach/remove event handler
    if (!this.state.showDocBgColorDropdown) {
      document.addEventListener(
        "click",
        this._handleDocBgColorDropdownOutsideClick,
        false,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleDocBgColorDropdownOutsideClick,
        false,
      );
    }
    this.setState(prevState => ({
      showDocBgColorDropdown: !prevState.showDocBgColorDropdown,
    }));
  };

  _handleDocBgColorDropdownOutsideClick = e => {
    const node = this.docBgColorDropdownRef.current;
    // ignore clicks on the component itself
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleDocBgColorDropdown();
  };

  _addNewComponent = (
    component,
    rowIndex,
    colIndex,
    newRow,
    dbRowIndex,
    dbColIndex,
    headerFooterType,
  ) => {
    if (component) {
      const { components, layout } = this.props;
      const addCommand = new AddComponentCommand({
        component,
        rowIndex,
        colIndex,
        newRow,
        headerFooterType,
        layout: [...layout],
        components: { ...components },
        docNo: this.props.docNo,
        docID: this.props.docID,
        mode: this.props.mode,
        addDocumentComponentAction: this.props.addDocumentComponentAction,
        addDealTableTab: this.props.addDealTableTab,
        removeComponentInDocument: this.props.removeComponentInDocument,
        deleteDocumentComponentAction: this.props.deleteDocumentComponentAction,
        dbRowIndex,
        dbColIndex,
      });
      this.props.executeCommand(addCommand);
    }
  };

  render() {
    if (this.props.isPdfDocument) {
      return <PdfDocument deleteComponent={this._removeSection} />;
    }
    return (
      <Fragment>
        <DocumentV2
          className=""
          docID={this.props.docID}
          mode={this.props.mode}
          isLocked={this.props.isLocked}
          showForm={this.props.showForm}
          docStage={this.props.docStage}
          sharingHash={this.props.sharingHash}
          isSharedDocument={this.props.isSharedDocument}
          isTemplateTypeForm={this.props.isTemplateTypeForm}
          layout={JSON.parse(JSON.stringify(this.props.layout))}
          // layoutString={this.state.layoutString}
          addComponentType={this.props.addComponentType}
          showOutlineView={this.state.showOutlineView}
          toggleOutlineView={this._toggleOutlineView}
          components={this.props.components}
          formFields={this.props.formFields}
          updateDocMeta={this.props.updateDocMeta}
          reactionsOnUndoClick={this.props.reactionsOnUndoClick}
          reactionsOnRedoClick={this.props.reactionsOnRedoClick}
          setDraggedSection={this._setDraggedSection}
          draggedSection={this.props.draggedSection}
          addComponent={this._addNewComponent}
          deleteComponent={this._removeSection}
          updateComponent={this._updateSection}
          updateOutlineLabel={this._updateOutlineLabel}
          reorderOutlineItemList={this._reorderOutlineItemList}
          toggleDocumentDiffView={this._toggleDocumentDiffView}
          updateHoveredSectionId={this.props.updateHoveredSectionId}
          hoveredActiveComponentId={this.props.hoveredActiveComponentId}
          clickedActiveComponentId={this.props.clickedActiveComponentType}
          clickedActiveComponentType={this.props.clickedActiveComponentType}
          preventClickedComponentIdUpdate={
            this.props.preventClickedComponentIdUpdate
          }
          updateDocumentClickedComponentID={
            this.props.updateDocumentClickedComponentID
          }
          setSectionDataForActiveSignatureInRightToolPane={
            this.props.setSectionDataForActiveSignatureInRightToolPane
          }
          coverpageIsVisible
          headerfooterIsVisible
          signatureWrapperRef={this.props.signatureWrapperRef}
          updateAddComponentinToolbarAction={
            this.props.updateAddComponentinToolbarAction
          }
          updateToolPaneData={this.props.updateToolPaneData}
          coverpageThemeAction={this.props.coverpageThemeAction}
          changeToolsView={this.props.changeToolsView}
          openClauseOptions={this.props.openClauseOptions}
          updateTemplateMeta={this.props.updateTemplateMeta}
          metaData={this.props.metaData}
          removeHighlightSelection={
            this.props.removeHighlightSelectionInDocument
          }
          setSectionDataForActivePaymentButtonInRightToolPane={
            this.props.setSectionDataForActivePaymentButtonInRightToolPane
          }
          isSharedDocumentPerma={this.props.isSharedDocumentPerma}
        />
        <UndoRedoObserver />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { mode } = props;
  let docID;
  let currency;
  // let sectionList = [];
  let openClauseOptions = false;
  let showForm = false;
  let docForm = [];
  let isTemplateTypeForm = false;
  let docTemplateId;
  let hasQuoteTableWrapper = false;
  let dealTableId = null;
  let dealtableType = null;
  // const sectionTypeList = [];
  let docStatus;
  let docStage;
  let docType;
  let docName;
  let isDocumentLocked = false;
  let showDocumentDiffView = false;
  let allSectionData;
  let metaData;
  let isPdfDocument = false;
  let pdfUrl = "";
  let signerData = "";
  let docNo;
  const {
    draggedSection,
    draggedFrom,
    layout,
    components,
    hoveredActiveComponentId,
    clickedActiveComponentId,
    clickedActiveComponentType,
    preventClickedComponentIdUpdate,
  } = state.DocumentStore;
  const { clickedSection } = state.EditorStore;
  const { addComponentType } = state.ToolPaneStore;
  if (mode === DOCUMENT) {
    const {
      docForm: documentForm,
      // document_order: order,
      document: {
        template_type: typeOfTemplate,
        showForm: showDocForm,
        pricelist,
        id,
        template_id: templateId,
        docType: documentType,
        status,
        stage,
        scope,
        name,
        meta_data: docMetaData,
        docNo: documentNo,
        isPdfDocument: isPdfDoc,
        pdfUrl: pdfFileUrl,
        image_base_url: imageBaseUrl,
        signatories,
      } = {},
      hasQuoteTableWrapper: hasTableWrapper,
      // content,
      showDocumentDiffView: showDocumentDiffViewValue,
    } = state.DocumentStore;
    // allSectionData = content.sections;
    // sent document form filling
    let disableFormMode = true;
    if (showDocForm) {
      disableFormMode = false;
    }
    isDocumentLocked =
      !(scope && scope.write) || stage !== DOCUMENT_STATUS_HASMAP.DRAFT;
    showForm =
      scope.write === false && scope.read === true && disableFormMode
        ? false
        : showDocForm;

    docStatus = status;
    docStage = stage;
    docName = name;
    docNo = documentNo;
    const { dealTableId: tableID, tableType } = state.QuotationStore;
    // sectionList = order;
    isTemplateTypeForm =
      typeOfTemplate && typeOfTemplate.toUpperCase() === FORM;
    docForm = documentForm;
    docID = id;
    currency = pricelist;
    docTemplateId = templateId;
    hasQuoteTableWrapper = hasQuoteTableWrapper || hasTableWrapper;
    dealTableId = tableID;
    dealtableType = tableType;
    docType = documentType;
    // sectionTypeList = content.sections.map(section => ({
    //   type: section.type,
    //   id: section.id,
    // }));
    showDocumentDiffView = showDocumentDiffViewValue;
    metaData = docMetaData;
    isPdfDocument = isPdfDoc;
    pdfUrl = `${imageBaseUrl}${pdfFileUrl}`;
    signerData = signatories;
  }
  if (mode === TEMPLATE) {
    const {
      // templateIdOrder: order,
      template: {
        template_type: typeOfTemplate,
        id,
        // content,
        is_locked: isLocked,
        status,
        meta_data: templateMetaData,
      },
      clauseOptions: { isOpen },
    } = state.TemplateStore;
    // allSectionData = content.sections;
    docID = id;
    docNo = id;
    // sectionList = order;
    isTemplateTypeForm =
      typeOfTemplate && typeOfTemplate.toUpperCase() === FORM;
    openClauseOptions = isOpen;
    // sectionTypeList = content.sections.map(section => ({
    //   type: section.type,
    //   id: section.id,
    // }));
    isDocumentLocked = isLocked || status !== DOCUMENT_STATUS_HASMAP.DRAFT;
    metaData = templateMetaData;
  }

  return {
    docID,
    // sectionList,
    docNo,
    docTemplateId,
    isTemplateTypeForm,
    hoveredActiveComponentId,
    clickedActiveComponentId,
    clickedActiveComponentType,
    preventClickedComponentIdUpdate,
    docStatus,
    docStage,
    docName,
    isDocumentLocked,
    docForm,
    docType,
    showForm,
    currency,
    openClauseOptions,
    hasQuoteTableWrapper,
    dealTableId,
    dealtableType,
    // sectionTypeList,
    draggedFrom,
    draggedSection,
    showDocumentDiffView,
    addComponentType,
    allSectionData,
    metaData,
    layout,
    components,
    isPdfDocument,
    pdfUrl,
    signerData,
    clickedSection,
  }; // below state can be moved down the hier archy to prevend rerenders
};

const mapDispatchToProps = {
  updateToolPaneData,
  fetchDynamicFields,
  changeDocFormValidFlag,
  addDealTableTab,
  updateDraggedSection,
  toggleDocumentDiffView,
  updateAddComponentinToolbarAction,
  updateDocumentClickedComponentID,
  // UNDO/REDO ACTIONS
  reactionsOnRedoClick,
  reactionsOnUndoClick,
  updateDocMeta,
  updateTemplateMeta,
  addDocumentComponentAction,
  deleteDocumentComponentAction,
  updateComponentsDBRowColIndexesAction,
  updateDocumentComponentAction,
  setSectionDataForActiveSignatureInRightToolPane,
  coverpageThemeAction,
  changeToolsView,
  updateHoveredSectionId: updateHoveredDocumentSectionId,
  updateOutlineLabel,
  removeHighlightSelectionInDocument,
  updateDocSaveIndicator,
  deleteDocSignerSection,
  setSectionDataForActivePaymentButtonInRightToolPane,
  executeCommand,
  removeComponentInDocument,
  nukeEditorState,
  initEditorState,
  updateEditorStateIfActive,
  undoComponentUpdate,
  forceUpdateEditorSectionIdAction,
  toggleCoverpageView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Document);



// WEBPACK FOOTER //
// ./src/components/Document/Document.js